import { SVGProps } from "react"

const ArrowLeftIconNew = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.40794 8.03701L9.97128 2.73158C10.2396 2.47573 10.6745 2.47573 10.9429 2.73158L11.5917 3.35037C11.8596 3.60582 11.8601 4.01982 11.5929 4.27586L7.18385 8.5003L11.5929 12.7248C11.8601 12.9808 11.8596 13.3948 11.5917 13.6503L10.9429 14.269C10.6746 14.5249 10.2396 14.5249 9.97127 14.269L4.40794 8.96359C4.13965 8.70771 4.13965 8.29289 4.40794 8.03701Z"
        fill="black"
      />
      <path
        d="M4.40794 8.03701L9.97128 2.73158C10.2396 2.47573 10.6745 2.47573 10.9429 2.73158L11.5917 3.35037C11.8596 3.60582 11.8601 4.01982 11.5929 4.27586L7.18385 8.5003L11.5929 12.7248C11.8601 12.9808 11.8596 13.3948 11.5917 13.6503L10.9429 14.269C10.6746 14.5249 10.2396 14.5249 9.97127 14.269L4.40794 8.96359C4.13965 8.70771 4.13965 8.29289 4.40794 8.03701Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M4.40794 8.03701L9.97128 2.73158C10.2396 2.47573 10.6745 2.47573 10.9429 2.73158L11.5917 3.35037C11.8596 3.60582 11.8601 4.01982 11.5929 4.27586L7.18385 8.5003L11.5929 12.7248C11.8601 12.9808 11.8596 13.3948 11.5917 13.6503L10.9429 14.269C10.6746 14.5249 10.2396 14.5249 9.97127 14.269L4.40794 8.96359C4.13965 8.70771 4.13965 8.29289 4.40794 8.03701Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M4.40794 8.03701L9.97128 2.73158C10.2396 2.47573 10.6745 2.47573 10.9429 2.73158L11.5917 3.35037C11.8596 3.60582 11.8601 4.01982 11.5929 4.27586L7.18385 8.5003L11.5929 12.7248C11.8601 12.9808 11.8596 13.3948 11.5917 13.6503L10.9429 14.269C10.6746 14.5249 10.2396 14.5249 9.97127 14.269L4.40794 8.96359C4.13965 8.70771 4.13965 8.29289 4.40794 8.03701Z"
        fill="black"
        fill-opacity="0.2"
      />
    </svg>
  )
}

export default ArrowLeftIconNew
